import { EventTracker, HoverState, Stack, ValueScale } from '@devexpress/dx-react-chart'
import { ArgumentAxis, BarSeries, Chart, Tooltip, ValueAxis } from '@devexpress/dx-react-chart-material-ui'
import { Box, styled } from '@mui/material'
import { green, red } from '@mui/material/colors'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { pathOr } from 'ramda'
import React from 'react'

import Legend from './legend'

const tooltipMap = {
  'Contacts Engaged': 'engaged',
  'Contacts Not Engaged': 'notEngaged',
  Error: 'error',
} as Record<string, string>

export type BarChartDatum = {
  engaged: number
  error: number
  name: string
  notEngaged: number
}

type Props = {
  data: BarChartDatum[]
  size?: number
}

const OverviewChart: React.FC<Props> = (props) => {
  const { data, size = 350 } = props

  const ChartTooltip: React.FC<Tooltip.ContentProps> = ({ text, targetItem, ...restProps }) => {
    const tooltipLabel = pathOr(text, [targetItem.point, tooltipMap[targetItem.series]], data)
    return <Tooltip.Content {...restProps} text={`${tooltipLabel} ${targetItem.series}`} targetItem={targetItem} />
  }

  return (
    <Paper>
      <Typography
        variant="h5"
        color="textSecondary"
        style={{
          textAlign: 'center',
          paddingTop: '20px',
          paddingBottom: '20px',
        }}
      >
        Message Delivery Overview
      </Typography>
      <Legend />
      <ChartContainer maxHeight={size}>
        <Chart height={data.length * 40 < size ? size : data.length * 40 + 100} data={data} rotated>
          <ValueScale name="name" />

          <ArgumentAxis />
          <ValueAxis
            tickFormat={() => (tick) => {
              if (Number(tick) % 1 === 0) {
                return tick
              }
              return ''
            }}
            scaleName="name"
          />
          <BarSeries
            name="Contacts Engaged"
            valueField="engaged"
            argumentField="name"
            scaleName="name"
            color={green.A700}
          />
          <BarSeries
            name="Contacts Not Engaged"
            valueField="notEngaged"
            argumentField="name"
            scaleName="name"
            color="#2f80ac"
          />
          <BarSeries name="Error" valueField="error" argumentField="name" scaleName="name" color={red.A200} />
          <Stack stacks={[{ series: ['Contacts Engaged', 'Contacts Not Engaged', 'Error'] }]} />
          <EventTracker />
          <HoverState />
          <Tooltip contentComponent={ChartTooltip} />
        </Chart>
      </ChartContainer>
    </Paper>
  )
}

const ChartContainer = styled(Box)({
  overflowY: 'auto',
  '& > .Target-root': {
    padding: 30,
  },
})

export default OverviewChart
